import { isEmbedded } from "@/remote/contract";
import { getFlagsConfig } from "@/config/flagsConfig";

/**
 * Where the settings index lands. Embedded, Administrators is shell-owned and the route guard turns
 * it away, so the index has to point at Connections — the one setting that stays.
 *
 * Reads the static flag config rather than `useFlag`: a redirect has no setup context. A Harness
 * override that disagrees with the matrix would land on the other Connections variant; the nav is
 * still correct, and both routes exist.
 */
const embeddedSettingsLanding = () => {
  let connectionsV2 = false;
  try {
    connectionsV2 = getFlagsConfig().CONNECTIONS_V2 === true;
  } catch {
    // Flags config not loaded yet — fall back to the v1 page.
  }
  return connectionsV2
    ? "customer-settings-connections-v2"
    : "customer-settings-connections";
};

export const customerSettingsRoutes = [
  {
    path: "settings",
    name: "custSettings",
    component: () => import("@/modules/Settings/views/Customer"),
    redirect: () => ({
      name: isEmbedded()
        ? embeddedSettingsLanding()
        : "customer-settings-administrators",
    }),
    children: [
      {
        path: "administrators",
        name: "customer-settings-administrators",
        component: () =>
          import("@/modules/Settings/views/Customer/Administrators/index.vue"),
      },
      {
        path: "connections",
        name: "customer-settings-connections",
        component: () =>
          import("@/modules/Settings/views/Customer/Connections/index.vue"),
      },
      {
        path: "connections-v2",
        name: "customer-settings-connections-v2",
        component: () =>
          import("@/modules/Settings/views/Customer/ConnectionsV2/index.vue"),
      },
      {
        path: "saml-sso",
        name: "customer-settings-saml-sso",
        component: () =>
          import("@/modules/Settings/views/Customer/Saml/index.vue"),
      },
    ],
  },
];

export const customerRoutes = {
  path: "",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),
  children: customerSettingsRoutes,
};
